var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.3157 38.2288C70.3157 35.5309 70.0924 33.5621 69.6089 31.5205H38.1729V43.6975H56.6252C56.2532 46.7237 54.2442 51.2809 49.7798 54.3432L49.7172 54.7511L59.6568 62.297L60.3454 62.3643C66.6698 56.6404 70.3157 48.2183 70.3157 38.2288Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1711 70.3119C47.2111 70.3119 54.8002 67.3951 60.3436 62.3638L49.778 54.3428C46.9507 56.2752 43.156 57.624 38.1711 57.624C29.3171 57.624 21.8022 51.9001 19.1234 43.9888L18.7307 44.0213L8.39554 51.86L8.26038 52.2282C13.7663 62.9469 25.0758 70.3119 38.1711 70.3119Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1242 43.9899C18.4174 41.9483 18.0083 39.7606 18.0083 37.5003C18.0083 35.2398 18.4174 33.0524 19.087 31.0107L19.0683 30.5757L8.60353 22.6113L8.26116 22.7709C5.99191 27.219 4.68982 32.2138 4.68982 37.5003C4.68982 42.7867 5.99191 47.7814 8.26116 52.2294L19.1242 43.9899Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1713 17.3749C44.4584 17.3749 48.6994 20.0364 51.1177 22.2605L60.567 13.2188C54.7636 7.9323 47.2114 4.6875 38.1713 4.6875C25.0758 4.6875 13.7663 12.052 8.26038 22.7707L19.0863 31.0104C21.8023 23.0989 29.3171 17.3749 38.1713 17.3749Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoog);
export default __webpack_public_path__ + "static/media/goog.0b1651c9c28ee9dfb34ca15063f0e5f8.svg";
export { ForwardRef as ReactComponent };